define(function(require,exports,module){
	var vendor = require( 'Responsive/vendor' ),
		domHelper = require( '../helpers/domHelper' ),
		Scaler = require('../helpers/Scaler'),
		gesso = require( 'gesso-js/gesso' ),
		gcd = require( '../math/gcd' ),
		cssClass = require( '../helpers/cssClass' ),
        Scheduler = require( "../workers/Scheduler" ),
        PitchRaster = require( "../workers/PitchRaster" ),
        imageLoader = require("image-loader/image-loader"),
        resourcePath = require('gameday-resource-path/gameday-resource-path'),
        abs = Math.abs,
        pow = Math.pow;

    var lineCap = "round";
    var lineJoin = "miter";
    var dirtImage;

    function RenderCanvas(pitchLayer){
    	var config = pitchLayer.config;
        var anchorOrder = this.anchorOrder = [];

    	this.pitchLayer=pitchLayer;
    	this.scalers=pitchLayer.scalers;
        this.scheduler = new Scheduler(config.renderURI);
        var SMOOTHING = this.scalers.smoothing;
        var SMOOTHING_ENABLED = !!SMOOTHING;

        if(!dirtImage && config.renderBallsInDirt) {
            imageLoader.load(resourcePath.get('pitchDirtCloud')).then(function(data) {
                // Set and stash it on a `define` level var.
                dirtImage = data.img;
            });
        }

        if(config.mode !=='2d'){
            this.canvas_bg = document.createElement('canvas');
        } else {
            //If in 2d mode, there's nothing to fade anyway
            config.fadeOldPitches = false;
        }
        this.canvas_fg = document.createElement('canvas');

        if(config.fadeOldPitches){
            this.canvas_history = document.createElement('canvas');
        }

        if(!this.canvas_fg.getContext){
        	this.isCanvas=false;
        }

        if(this.canvas_bg){
            this.gtx_bg = gesso(this.canvas_bg);
            this.ctx_bg = this.gtx_bg._ctx_;
            this.ctx_bg.imageSmoothingEnabled = SMOOTHING_ENABLED;

            if (SMOOTHING_ENABLED) {
                this.ctx_bg.imageSmoothingQuality = SMOOTHING;
            }

            this.canvas_bg.setAttribute("data-responsive-pitch-fx-hide",true)
            this.canvas_bg.className = cssClass("render") + " " + cssClass("trails");
            anchorOrder.push(this.canvas_bg);
        }

        this.gtx_fg = gesso(this.canvas_fg);
        this.ctx_fg = this.gtx_fg._ctx_;
        this.ctx_fg.imageSmoothingEnabled = SMOOTHING_ENABLED;

        if (SMOOTHING_ENABLED) {
            this.ctx_fg.imageSmoothingQuality = SMOOTHING;
        }

        this.canvas_fg.setAttribute("data-responsive-pitch-fx-hide",true)
        this.canvas_fg.className = cssClass("render") + " " + cssClass("strikezone");
        anchorOrder.push(this.canvas_fg);

        if (config.perspective === 'pitcher'){
            anchorOrder.reverse();
        }

        if(config.fadeOldPitches){
            this.gtx_history = gesso(this.canvas_history);
            this.ctx_history = this.gtx_history._ctx_;
            this.ctx_history.imageSmoothingEnabled = SMOOTHING_ENABLED;

            if (SMOOTHING_ENABLED) {
                this.ctx_history.imageSmoothingQuality = SMOOTHING;
            }

            this.canvas_history.setAttribute("data-responsive-pitch-fx-hide",true)
            this.canvas_history.className = cssClass("render") + " " + cssClass("history");
            anchorOrder.unshift(this.canvas_history);
        }

        if(this.canvas_bg){
            this.gtx_bg.globalAlpha(1)
                .globalCompositeOperation("source-over")
                .miterLimit(1);
        }

        var pxRatio = ~~(this.ctx_fg.backingStorePixelRatio || this.ctx_fg[vendor.id + 'BackingStorePixelRatio']);

        // If canvas is already doing the heavy lifting for scaling, let it do it's thing
        if (pxRatio > 1) {
            Scaler.prototype.canvasDensity = 1;
        }
    }

    RenderCanvas.prototype={
    	isCanvas 		  : true,
        isStrikeZoneDrawn : false,
        hidden          : true,
        anchor 			: function(){
            var order = this.anchorOrder;
            var len = order.length;
            var i = 0;
            var view = this.pitchLayer.view;
            for (; i < len; i++) {
                domHelper.append(view, order[i]);
            }
        },
        destroy 		: function(){
            this.isStrikeZoneDrawn=false;
            domHelper.remove(this.canvas_history);
            domHelper.remove(this.canvas_bg);
            domHelper.remove(this.canvas_fg);

            if (this.canvas_history) {
                this.canvas_history.width=1;
                this.canvas_history.height=1;
            }
            if (this.canvas_bg){
                this.canvas_bg.width=1;
                this.canvas_bg.height=1;
            }
            if (this.canvas_fg) {
                this.canvas_fg.width=1;
                this.canvas_fg.height=1;
            }

            this.canvas_history = null;
            this.canvas_bg = null;
            this.canvas_fg = null;
            this.gtx_fg = null;
            this.ctx_fg = null;
            this.gtx_bg = null;
            this.ctx_bg = null;
            this.gtx_history = null;
            this.ctx_history = null;
            this.anchorOrder = null;
        },
        resize 			: function(){
            var width = this.scalers.width,
                height= this.scalers.height;

            if (this.canvas_bg) {
                this.canvas_bg.height = height;
                this.canvas_bg.width = width;
            }

            this.canvas_fg.height = height;
            this.canvas_fg.width = width;
            this.isStrikeZoneDrawn = false;

            if(this.canvas_history){
                this.canvas_history.height = height;
                this.canvas_history.width = width;
            }
        },
        renderImage : function(){
            var clip = this.pitchLayer.config.clip;
            if(this.pitchLayer.config.mode !== '2d'){
                this.gtx_fg.globalCompositeOperation('destination-over')
                    .drawImage(this.canvas_bg,0,0)
                    .globalCompositeOperation('source-over');
            }

            if(clip){
                if(!this.canvas_out){
                    this.canvas_out = document.createElement('canvas');
                    this.gtx_out = gesso(this.canvas_out);
                }
                var canvas_out=this.canvas_out,
                    fakep = new PitchRaster({}, this),
                    scalers = this.scalers,
                    topLeftCorner = fakep.pointOnGrid(-scalers.homePlateWidth / 2, scalers.strikeZone.szTop, -scalers.homePlateFrontY),
                    bottomRightCorner = fakep.pointOnGrid(scalers.homePlateWidth / 2, scalers.strikeZone.szBot, -scalers.homePlateFrontY);

                canvas_out.width = (clip.width || (bottomRightCorner[0] - topLeftCorner[0]) ) * scalers.canvasDensity;
                canvas_out.height = (clip.height || (bottomRightCorner[1] - topLeftCorner[1]) ) * scalers.canvasDensity;

                this.gtx_out.globalCompositeOperation('copy')
                    .drawImage(this.canvas_fg, -scalers.bounds.left, -scalers.bounds.top);
            }
            return (canvas_out || this.canvas_fg).toDataURL();
        },
        getSizerURI 	: function(){
			var scalers=this.pitchLayer.scalers,
            	mindims = gcd(this.scalers.base_width, this.scalers.base_height);

            this.canvas_fg.width = this.scalers.base_width / mindims;
            this.canvas_fg.height = this.scalers.base_height / mindims;

            this.gtx_fg.beginPath()
                .clearRect(0, 0, this.canvas_fg.width, this.canvas_fg.height)
                .closePath();

            return this.canvas_fg.toDataURL();

        },
        getStrikeZoneValues : function(pitch) {
            var scalers = this.scalers;
            var sz = (pitch.szTop && pitch.szBot && !scalers.defaultStrikeZone) ? pitch : scalers.strikeZone;

            return {
                topLeftCorner: pitch.raster.pointOnGrid(-1 * pitch.szWidth / 2, sz.szTop, -pitch.szDepth),
                bottomRightCorner: pitch.raster.pointOnGrid(pitch.szWidth / 2, sz.szBot, -pitch.szDepth)
            }
        },
        draw2Dpitch : function (pitch) {
            var scalers=this.scalers,
                pitchLayer=this.pitchLayer;

            if (!this.isStrikeZoneDrawn) {
                this.drawStrikeZone(pitch);
            }
            if ((scalers.mode === '2d' || pitchLayer.config.mode ==='2d') && pitch.is3DPitch) {
                pitchLayer.drawBall(pitch, pitch.getArrayOfPoints(scalers.numberOfAnimationPoints).slice(-1)[0]);
                return;
            }

            pitchLayer.drawBall(pitch,pitch.raster.points2D());
        },
        drawPitch : function (pitch) {
            var scalers=this.scalers,
                pitchLayer=this.pitchLayer;

            if (scalers.mode === '2d' || pitchLayer.config.mode ==='2d' || !pitch.is3DPitch) {
                this.draw2Dpitch(pitch);
                return;
            }

            if (!this.isStrikeZoneDrawn) {
                this.drawStrikeZone(pitch);
            }
            // 3D Perspective Path
            this.drawPitchPath(pitch);
        },
        drawBall : function (pitch, pt, pt2) {
            if (this.pitchLayer.config.domBalls) {
                return;
            }
            var config = this.pitchLayer.config,
            	scalers=this.pitchLayer.scalers,
                bottomRightCorner = this.getStrikeZoneValues(pitch).bottomRightCorner,
                szBorder = scalers.szBorder * 2,
                color = pitch.shader.ball,
                s_offset = 2 / scalers.base_width * scalers.x,
                fsize = ( scalers.fontSize / scalers.base_width * scalers.fakeBallSize).toFixed(2),
                font = 'bold ' + fsize + 'em ' + config.font,
	            lineWidth = pt[4] || 0,
                strokeWidth = (scalers.canvasDensity > 1 ? scalers.canvasDensity : 1) * scalers.ballStrokeWidth,
                diameter = scalers.fakeBallSize,
                x = pt[0],
                y = pt[1],
                boundBallX = x,// + (x && abs(x)/x)*(safeXY.x - ballX),
                boundBallY = y,// + (y && abs(y)/y)*(safeXY.y - ballY);
                renderBallInDirt = pitch.ballInDirt && config.renderBallsInDirt && dirtImage;

            if (scalers.perspective === 'pitcher' && this.gtx_bg) {
                this.gtx_bg.globalCompositeOperation('destination-out')
                    .globalAlpha()
                    .beginPath()
                    .arc(boundBallX, boundBallY, scalers.fakeBallSize / 1.5, 0, Math.PI * 2, true)
                    .fillStyle(0,0,0,0.0)
                    .fill()
                    .closePath();
            }

            this.gtx_fg.globalCompositeOperation(renderBallInDirt ? 'destination-over' : 'source-over')
                .globalAlpha(1)
                .beginPath()
                .arc(boundBallX, boundBallY, renderBallInDirt ? scalers.fakeBallSize / 1.1 : scalers.fakeBallSize, 0, Math.PI * 2, true)
                .stroke({
                    style: pitch.shader.ballStroke
                })
                .lineWidth(strokeWidth);

            /*
             * Balls in dirt should be rendered via 'destination-over', which means we need to render
             * each part in reverse order, first the dirt, then the pithc num, then the fill color..
             * This allows for said balls to render _behind_ the strikezone.. as they didn't fly far enough to cross it.
             * The 'else' clause renders the pitch via source-over, as normal (rendering it ontop of the strikezone)
             */
            if(renderBallInDirt){
                if(boundBallY < (bottomRightCorner[1] + szBorder)) {
                    /*
                     * If the ball is in the dirt AND behind strikezone
                     * Is the center of the ball above the bottom line of the zone?
                     * Draw the dirt WITHIN the ball, so it doesn't render over pitch paths
                     */
                    this.gtx_fg.save();
                    this.gtx_fg.beginPath()
                        .arc(boundBallX, boundBallY, scalers.fakeBallSize, 0, Math.PI * 2, true)
                        .clip();
                    this.gtx_fg.drawImage(dirtImage, boundBallX - ((scalers.fakeDirtCloudSize.width + scalers.fakeBallSize / 2) / 2) - 10, boundBallY - (scalers.fakeDirtCloudSize.height / 2) - 5, scalers.fakeDirtCloudSize.width, scalers.fakeDirtCloudSize.height);
                    this.gtx_fg.restore();
                } else {
                    this.gtx_fg.drawImage(dirtImage, boundBallX - ((scalers.fakeDirtCloudSize.width + scalers.fakeBallSize / 2) / 2), boundBallY - (scalers.fakeDirtCloudSize.height / 2) - 5, scalers.fakeDirtCloudSize.width, scalers.fakeDirtCloudSize.height);
                }

                this.gtx_fg.globalCompositeOperation('destination-over')
                .globalAlpha(1)
                .beginPath()
                .arc(boundBallX, boundBallY, renderBallInDirt ? scalers.fakeBallSize / 1.1 : scalers.fakeBallSize, 0, Math.PI * 2, true)
                .stroke({
                    style: pitch.shader.ballStroke
                })
                .lineWidth(strokeWidth)
                .text({
                    align: "center",
                    baseline: "middle"
                })
                .font(font)
                .fillText(pitch.num || " " + "", boundBallX, boundBallY)
                .fillStyle(color)
                .fill()
                .closePath()
                .beginPath()
                .fillStyle(pitch.shader.text)
                .shadow({
                    offsetX: scalers.canvasDensity,
                    offsetY: scalers.canvasDensity,
                    blur: 1
                })
                .globalCompositeOperation("source-over")
                .closePath();
            } else {
                /* Fill solid first to avoid transparency bug in Android */
                this.gtx_fg
                .globalCompositeOperation('source-over')
                .globalAlpha(1)
                .beginPath()
                .arc(boundBallX, boundBallY, renderBallInDirt ? scalers.fakeBallSize / 1.1 : scalers.fakeBallSize, 0, Math.PI * 2, true)
                .stroke({
                    style: pitch.shader.ballStroke
                })
                .lineWidth(strokeWidth)
                .fillStyle(color)
                .fill()
                .closePath()
                // Create a new path for rendering just the stroke, being sure to
                // keep the stroke withing the bounds of the ball, even with a larger strokeWidth
                .beginPath()
                .arc(boundBallX, boundBallY, scalers.fakeBallSize - strokeWidth/2, 0, Math.PI * 2, true)
                .stroke()
                .closePath()
                .beginPath()
                .font(font)
                .fillStyle(pitch.shader.text)
                .shadow({
                    offsetX: scalers.canvasDensity,
                    offsetY: scalers.canvasDensity,
                    blur: 1
                })
                .text({
                    align: "center",
                    baseline: "middle"
                })
                .fillText(pitch.num || " " + "", boundBallX, boundBallY)
                .closePath();
            }

            /* Diagnostics */
            if(config.diagnostics){
                var newpt = pitch.raster.pointOnGrid(pitch.coords.px,pitch.coords.pz,-pitch.szDepth)
                this.gtx_fg.globalAlpha(1)
                    .globalCompositeOperation("source-over")
                    .beginPath()
                    .arc(newpt[0], newpt[1], scalers.fakeBallSize, 0, Math.PI * 2, true)
                    .stroke({
                        style: "rgba(0,0,0,1)"
                    })
                    .lineWidth(strokeWidth)
                    .stroke()
                    .fillStyle(pitch.shader.text)
                    .text({
                        align: "center",
                        baseline: "middle"
                    })
                    .fillText((pitch.num || " ") + "", newpt[0], newpt[1])
                    .closePath()
                }
        },

        drawPitchStart : function (pitch,pt) {
            var scalers = this.scalers;
            if(scalers.drawStart || scalers.diagnostics){
            var coords = pitch.coords;
            var start = pitch.raster.pointOnGrid(coords.x0,coords.z0,-coords.y0)
            this.gtx_fg.beginPath()
                .lineWidth(2)
                .strokeStyle("white")
                // .arc(boundBallX, boundBallY, scalers.fakeBallSize, 0, Math.PI * 2, true)
                .arc(start[0], start[1], 10, 0, Math.PI * 2, true)
                .stroke()
                .closePath();
            }
        },

        drawPitchPath : function (pitch) {
            var that=this,
                scalers = this.scalers,
            	points=pitch.getArrayOfPoints(scalers.numberOfAnimationPoints),
            	last = points.length - 1,
                drawIn = scalers.timing;

           	points.forEach(function(finish,index){
           		if(index!==0){
		            that.scheduler.addAction(function () {
						this.drawPitchPathFragment(pitch, points[index-1], finish);
					}, drawIn, that);
           		}
           	});

            if(scalers.perspective !== 'side') {
	            this.scheduler.addAction(function () {
	                this.pitchLayer.drawBall(pitch, points[last], points[last-1] || points[last]);
                    this.drawPitchStart(pitch);
    			}, drawIn, this);
            }
        },
        drawPitchPathFragment : function(pitch,pt1,pt2){
            var	color = pitch.shader.fill,
                lineWidth = pt2[3];
            var scalers = this.scalers;
            var isPitcherPerspective = scalers.perspective === 'pitcher';

            if (isPitcherPerspective ) {
                this.gtx_bg
                    .beginPath()
                    .globalCompositeOperation('destination-over')
                    .miterLimit(Math.round(lineWidth / 2))
                    .line({
                        cap: lineCap,
                        join: lineJoin
                    })
                    .shadow({
                        color: 'rgba(0,0,0,1)',
                        blur: 0,
                        offsetX: 1,
                        offsetY: 1
                    })
                    .moveTo(pt1[0], pt1[1])
                    .line({
                        to: [pt2[0], pt2[1]],
                        width: lineWidth
                    })
                    .strokeStyle("rgba(0,0,0,1)")
                    .stroke()
                    .globalCompositeOperation('source-over')
                    .globalAlpha(1.0)
                    .shadowColor("transparent")
                    .closePath();
            }

            this.gtx_bg
                .beginPath()
                .globalCompositeOperation(isPitcherPerspective ? 'source-over' : 'source-over')
                .miterLimit(Math.round(lineWidth / 2))
                .line({
                    cap: lineCap,
                    join: lineJoin
                })
                .moveTo(pt1[0], pt1[1])
                .line({
                    to: [pt2[0], pt2[1]],
                    width: lineWidth
                })
                .strokeStyle(color)
                .strokeStyle(pitch.gradient || color)
                .stroke()
                .globalCompositeOperation('source-over')
                .globalAlpha(1.0)
                .closePath();

        },
        drawHistory : function(){
            if(this.pitchLayer.config.fadeOldPitches && this.canvas_history){
                this.scheduler.addAction(function () {
                    this.gtx_history.drawImage(this.canvas_bg,0,0);

                    this.canvas_bg.width = this.canvas_bg.width;
                    this.gtx_bg.beginPath()
                        .clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
                        .closePath();

                    this.gtx_bg.beginPath()
                        .fillStyle("rgba(0,0,0,0.1)")
                        .fillRect(0, 0, 1, 1)
                        .closePath();

                }, 0, this);
            }
        },
        drawStrikeZone : function (pitch) {
            var that=this,
            	scalers=this.scalers,
            	sz = (pitch.szTop && pitch.szBot && !scalers.defaultStrikeZone) ? pitch : scalers.strikeZone,
                topLeftCorner = this.getStrikeZoneValues(pitch).topLeftCorner,
                bottomRightCorner = this.getStrikeZoneValues(pitch).bottomRightCorner,
                grid = [
                    [],
                    [],
                    []
                ],
                outliers = [],
                hotcold = this.pitchLayer.hotcold,
                ogMode = !!(hotcold && hotcold.sitModel),

                hotColdZones = scalers.hotColdZones && hotcold && (ogMode || hotcold.batter),
                zones;

            var strokeWidth = scalers.hotColdZoneGridStroke;
            var strokeHalf = strokeWidth / 2;
            var borderWidth = scalers.hotColdZoneBorderStroke;
            var borderHalf = borderWidth / 2;
            var gridOpacity = scalers.hotColdZoneGridOpacity;
            var colorOpacity = scalers.hotColdZoneColorOpacity;

            var isPitcherPerspective = scalers.perspective === 'pitcher';
            this.gtx_fg.beginPath()
                .fillStyle("rgba(0,0,0,0.1)")
                .fillRect(0, 0, 1, 1)
                .closePath();

            if(scalers.diagnostics){
                var scaleBot = [-scalers.homePlateWidth / 2 - 1,0];
                var feet = 8;
                var segment = 0;
                var scaleStep;
                var scaleStepTo;
                var ruleWidth;

                for(; segment < feet; segment+=0.5){
                    scaleStep=pitch.raster.pointOnGrid(scaleBot[0], scaleBot[1], -pitch.szDepth);
                    scaleStepTo=pitch.raster.pointOnGrid(scaleBot[0], scaleBot[1]+=0.5, -pitch.szDepth);
                    ruleWidth = scalers.pixelFoot*(segment%1 || 1);
                    this.gtx_bg
                        .beginPath()
                        .globalCompositeOperation('source-over')
                        .globalAlpha(1.0)
                        .lineWidth(4.0)
                        .moveTo(scaleStep[0] - ruleWidth, scaleStep[1])
                        .lineTo(scaleStep[0] + ruleWidth, scaleStep[1])
                        .shadowColor("transparent")
                        .strokeStyle("red")
                        .stroke()
                        .font('bold 1.4em ' + scalers.font)
                        .fillStyle("red")
                        .text({
                            align: "center",
                            baseline: "middle"
                        })
                        .fillText(segment,scaleStep[0] + scalers.pixelFoot, scaleStep[1])
                        .closePath();

                    this.gtx_bg
                        .beginPath()
                        .globalCompositeOperation('source-over')
                        .globalAlpha(1.0)
                        .lineWidth(3.0)
                        .moveTo(scaleStep[0], scaleStep[1])
                        .lineTo(scaleStepTo[0], scaleStepTo[1])
                        .shadowColor("transparent")
                        .strokeStyle("red")
                        .stroke()
                        .closePath();
                }

            }

            if (!hotColdZones) {

                this.drawNOHCStrikeZone(topLeftCorner, bottomRightCorner);
                return;
            }

            var count = 0,
                i = 0,
                ogMode = !!hotcold.sitModel,
                zones = [].concat((ogMode && hotcold.sitModel ? hotcold.sitModel.zones : hotcold && hotcold.batter ) || []);


            if (!zones.length) {
                this.drawNOHCStrikeZone(topLeftCorner, bottomRightCorner);
                return;
            }

            this.drawStrikeZoneGrid(topLeftCorner, bottomRightCorner);
            /*
             * Populate inner strike zone data
             * leaving over outlier data for later
             */
            while (zones.length && i < 3) {
                grid[i].push({
                    data: zones.shift(),
                    temp: ogMode ? zones.shift() : null
                });

                count += 1;

                if (count === 3) {
                    i += 1;
                    count = 0;
                }
            }

            // Populate outlier zones of strike zone data
            while (zones.length) {
                outliers.push({
                    data: zones.shift(),
                    temp: ogMode ? zones.shift() : null
                });
            }

            if (isPitcherPerspective) {
                outliers = [
                    outliers[1],
                    outliers[0],
                    outliers[3],
                    outliers[2]
                ];
            }

            outliers.forEach(function (e, i) {
                var szBorder = scalers.szBorder * 2,
                    x,
                    y;

                switch (i) {
                    case 0:
                        x = topLeftCorner[0] - (szBorder);
                        y = topLeftCorner[1] - (szBorder);
                        break;

                    case 1:
                        x = topLeftCorner[0] - (szBorder) + ((bottomRightCorner[0] - topLeftCorner[0] + (szBorder) * 2) / 2);
                        y = topLeftCorner[1] - (szBorder);
                        break;

                    case 2:
                        x = topLeftCorner[0] - (szBorder);
                        y = topLeftCorner[1] - (szBorder) + ((bottomRightCorner[1] - topLeftCorner[1] + (szBorder) * 2) / 2);
                        break;

                    case 3:
                        x = topLeftCorner[0] - (szBorder) + ((bottomRightCorner[0] - topLeftCorner[0] + (szBorder) * 2) / 2);
                        y = topLeftCorner[1] - (szBorder) + ((bottomRightCorner[1] - topLeftCorner[1] + (szBorder) * 2) / 2);
                        break;

                    default:
                        // do nothing
                        break;
                }

                var boundX = (bottomRightCorner[0] - topLeftCorner[0] + (szBorder) * 2) / 2;
                var boundY = (bottomRightCorner[1] - topLeftCorner[1] + (szBorder) * 2) / 2;

                that.gtx_fg
                    .beginPath()
                    .shadowColor("transparent")
                    .lineWidth(borderWidth)
                    .fillStyle(e.data.color || scalers.hotColdZoneOutlierDefaultColor)
                    .strokeStyle(scalers.hotColdZoneOutlierBorderColor)
                    .clearRect(x-borderHalf, y-borderHalf, boundX+borderHalf, boundY+borderHalf)
                    .globalAlpha(gridOpacity)
                    .strokeRect(x, y, boundX, boundY)
                    .globalAlpha(colorOpacity)
                    .fillRect(x, y, boundX, boundY)
                    .globalAlpha(1.0)
                    .closePath();
            });

            this.gtx_fg
                .beginPath()
                .shadowColor("transparent")
                .clearRect(
                    topLeftCorner[0] - 1,
                    topLeftCorner[1] - 1,
                    bottomRightCorner[0] - topLeftCorner[0] + 2,
                    bottomRightCorner[1] - topLeftCorner[1] + 2
                )
                .closePath();

            grid.forEach(function (row, y) {
                if (isPitcherPerspective) {
                    row = row.slice(0).reverse();
                }
                row.forEach(function (zone, x) {
                	var coords={};
                    ([x, this.y]).forEach(function (e, i) {
	                    switch (e) {
	                        case 0:
	                            e = topLeftCorner[i];
	                            break;

	                        case 1:
	                            e = topLeftCorner[i] + ((bottomRightCorner[i] - topLeftCorner[i]) / 3);
	                            break;

	                        case 2:
	                            e = topLeftCorner[i] + (((bottomRightCorner[i] - topLeftCorner[i]) / 3) * 2);
	                            break;

	                        default:
	                            // do nothing!
	                            break;
	                    }

	                    i === 0 ? coords.x = e : coords.y = e;
	                });
                    var boundX = (bottomRightCorner[0] - topLeftCorner[0]) / 3;
                    var boundY = (bottomRightCorner[1] - topLeftCorner[1]) / 3;
                    that.gtx_fg
                        .beginPath()
                        .globalCompositeOperation('source-over')
                        .globalAlpha(colorOpacity)
                        .clearRect(coords.x-strokeHalf, coords.y-strokeHalf, boundX+strokeHalf, boundY+strokeHalf)
                        .lineWidth(strokeWidth)
                        .fillStyle(zone.data.color || scalers.hotColdZoneDefaultColor)
                        .fillRect(coords.x, coords.y, boundX, boundY)
                        .globalAlpha(gridOpacity)
                        .strokeStyle(scalers.hotColdZoneGridColor)
                        .strokeRect(coords.x, coords.y, boundX, boundY)
                        .closePath();
                }, { y: y });
            });

            this.gtx_fg
                .globalAlpha(gridOpacity)
                .beginPath()
                .globalCompositeOperation('source-over')
                .shadowColor("transparent")
                .strokeStyle(scalers.hotColdZoneOutlierBorderColor)
                .strokeRect(
                    topLeftCorner[0] - scalers.szBorder * 2,
                    topLeftCorner[1] - scalers.szBorder * 2,
                    bottomRightCorner[0] - topLeftCorner[0] + scalers.szBorder * 4,
                    bottomRightCorner[1] - topLeftCorner[1] + scalers.szBorder * 4
                )
                .globalAlpha(1.0)
                .closePath();

            this.isStrikeZoneDrawn = true;
        },
        drawNOHCStrikeZone : function (topLeftCorner, bottomRightCorner) {
        	var scalers=this.scalers;
            var szBorder = scalers.szBorder;
            var x = topLeftCorner[0] - szBorder;
            var y = topLeftCorner[1] - szBorder;
            var boundX = (bottomRightCorner[0] - topLeftCorner[0] + (szBorder) * 2);
            var boundY = (bottomRightCorner[1] - topLeftCorner[1] + (szBorder) * 2);
            var strokeWidth = scalers.hotColdZoneGridStroke;
            var strokeHalf = strokeWidth / 2;

            var gridOpacity = scalers.hotColdZoneGridOpacity;
            var colorOpacity = scalers.hotColdZoneColorOpacity;

            this.gtx_fg
                .beginPath()
                .shadowColor("transparent")
                .globalAlpha(colorOpacity)
                .lineWidth(strokeWidth)
                .fillStyle(scalers.hotColdZoneDefaultColor)
                .fillRect(x, y, boundX, boundY)
                .globalAlpha(gridOpacity)
                .strokeStyle(scalers.hotColdZoneBorderColor)
                .lineWidth(strokeWidth)
                .strokeRect(x, y, boundX, boundY)
                .closePath()
                .globalAlpha(1.0)

                .clearRect(
                    topLeftCorner[0] - 1,
                    topLeftCorner[1] - 1,
                    bottomRightCorner[0] - topLeftCorner[0] + 2,
                    bottomRightCorner[1] - topLeftCorner[1] + 2
                )
                .globalAlpha(colorOpacity)
                .fillStyle(scalers.hotColdZoneDefaultColor)
                .fillRect(
                    topLeftCorner[0],
                    topLeftCorner[1],
                    bottomRightCorner[0] - topLeftCorner[0],
                    bottomRightCorner[1] - topLeftCorner[1]
                )
                .globalAlpha(gridOpacity)
                .strokeStyle(scalers.hotColdZoneGridColor)
                .strokeRect(
                    topLeftCorner[0],
                    topLeftCorner[1],
                    bottomRightCorner[0] - topLeftCorner[0],
                    bottomRightCorner[1] - topLeftCorner[1]
                )
                .globalAlpha(1.0)
                .closePath();

            this.drawStrikeZoneGrid(topLeftCorner, bottomRightCorner);
            this.isStrikeZoneDrawn = true;
        },

        drawStrikeZoneGrid: function(topLeftCorner, bottomRightCorner){
            var scalers = this.scalers;

            if(scalers.grid || scalers.diagnostics){
                var gridScaleY = (bottomRightCorner[1] - topLeftCorner[1])/3;
                var gridScaleX = (bottomRightCorner[0] - topLeftCorner[0])/3;
                var boundY = scalers.height;
                var boundX = scalers.width;
                var gridLinesY = boundY / gridScaleY;
                var gridLinesX = boundX / gridScaleX;
                var gridStep;
                var gridLine=0;
                var startY = topLeftCorner[1] % gridScaleY;
                var startX = topLeftCorner[0] % gridScaleX;
                var gridColor = scalers.backgroundGridColor;
                if(scalers.diagnostics){
                    gridColor = "lime";
                }
                for(gridStep = startY; gridLine < gridLinesY; gridLine++ ){
                    this.gtx_bg
                        .beginPath()
                        .globalCompositeOperation('destination-over')
                        .globalAlpha(1.0)
                        .lineWidth(1.0)
                        .moveTo(0, gridStep)
                        .lineTo(boundX, gridStep)
                        .shadowColor("transparent")
                        .strokeStyle(gridColor)
                        .stroke()
                        .closePath();
                    gridStep +=gridScaleY;
                }
                gridLine=0;
                for(gridStep = startX; gridLine < gridLinesX; gridLine++ ){
                    this.gtx_bg
                        .beginPath()
                        .globalCompositeOperation('destination-over')
                        .globalAlpha(1.0)
                        .lineWidth(1.0)
                        .moveTo(gridStep, 0)
                        .lineTo(gridStep, boundY)
                        .shadowColor("transparent")
                        .strokeStyle(gridColor)
                        .stroke()
                        .closePath();
                    gridStep +=gridScaleX;
                }
            }
        },
        draw2DStrikeZone : function (pitch) {
            this.drawStrikeZone(pitch);
        },
        hideCanvas : function (cb) {
            if (this.hidden) {
                cb && cb();
                return;
            }
            this.hidden = true;
            if (this.canvas_bg) {
                this.canvas_bg.setAttribute("data-responsive-pitch-fx-hide",true);
            }
                this.canvas_fg.setAttribute("data-responsive-pitch-fx-hide",true);
            if(this.canvas_history){
                this.canvas_history.setAttribute("data-responsive-pitch-fx-hide",true);
            }
            if (cb) {
                setTimeout(cb, 500);
            }
        },

        showCanvas : function (cb) {
            if (!this.hidden) {
                cb && cb();
                return;
            }
            this.hidden = false;
            if (this.canvas_bg) {
                this.canvas_bg.setAttribute("data-responsive-pitch-fx-hide",false);
            }
            this.canvas_fg.setAttribute("data-responsive-pitch-fx-hide",false);
            if(this.canvas_history){
                this.canvas_history.setAttribute("data-responsive-pitch-fx-hide",false)
            }
            if (cb) {
                setTimeout(cb, 500);
            }

        },

        clear : function () {
            this.isStrikeZoneDrawn=false;
            this.scheduler.clear();
            this.hideCanvas();

            if(this.gtx_bg){
                this.gtx_bg.beginPath()
                    .clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
                    .closePath();

                this.canvas_bg.width = this.canvas_bg.width;

                this.gtx_bg.beginPath()
                    .clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
                    .closePath();

                this.gtx_bg.beginPath()
                    .fillStyle("rgba(0,0,0,0.1)")
                    .fillRect(0, 0, 1, 1)
                    .closePath();

                this.gtx_bg.beginPath()
                    .clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
                    .closePath();
            }

            this.resize();

            // now foreground
            this.gtx_fg.beginPath()
                .clearRect(0, 0, this.canvas_fg.width, this.canvas_fg.height)
                .closePath();

            this.canvas_fg.width = this.canvas_fg.width;

            this.gtx_fg.beginPath()
                .clearRect(0, 0, this.canvas_fg.width, this.canvas_fg.height)
                .closePath();
            this.gtx_fg.beginPath()
                .fillStyle("rgba(0,0,0,0.1)")
                .fillRect(0, 0, 1, 1)
                .closePath();

            this.showCanvas();

            this.gtx_fg.beginPath()
                .clearRect(0, 0, this.canvas_fg.width, this.canvas_fg.height)
                .closePath();

            this.isStrikeZoneDrawn=false;
     },

     run : function(){
        if(this.pitchLayer.config.renderURI){
            this.scheduler.addAction(this.pitchLayer.renderImage,0,this.pitchLayer);
        }
        this.scheduler.run();
     }

    };
    return RenderCanvas;
});
